module.exports = __webpack_public_path__ + "static/media/Z7.6c063e0f.jpg";